import { useQuery } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { SMALL_ROW_LIMIT } from 'constants/tableConstants'
import { CompanyProfileSearchState, GetCompanyProfileResponse } from 'types/getCompanyProfiles'

const { SECURE_BASE_URL } = config!

const getQueryParams = (req: CompanyProfileSearchState) => {
  const { companyName, companyType, offset } = req

  let queryParams = `limit=${SMALL_ROW_LIMIT}&offset=${offset ?? 0}`

  if (companyName) queryParams += `&name=${encodeURIComponent(companyName.toUpperCase())}`
  if (companyType && companyType !== 'all') queryParams += `&groupType=${companyType}`

  queryParams += '&operation=listGroup'

  return queryParams
}

const getCompanyProfiles = async (req: CompanyProfileSearchState): Promise<GetCompanyProfileResponse> => {
  const { response: companyProfilesResponse } = await callAxios<{
    response: any
  }>({
    url: `${SECURE_BASE_URL}/listgroup?${getQueryParams(req)}`,
    method: 'GET',
  })

  const mappedResponse: GetCompanyProfileResponse = {
    data:
      companyProfilesResponse?.data?.map((item: any): GetCompanyProfileResponse['data'][number] => ({
        refId: item?.id ?? '',
        companyName: item?.name ?? '',
        companyType: item?.groupType ?? '',
        companyUsers: item?.relatedSuppliers?.length ?? 0,
        relatedSuppliers:
          item?.relatedSuppliers?.map((item: any) => ({
            supplierName: item?.supplierName ?? '',
            supplierId: item?.id ?? '',
          })) ?? [],
        remarks: '',
      })) ?? [],
    metadata: companyProfilesResponse?.metaData,
  }

  return mappedResponse
}

export const useGetCompanyProfiles = (req: CompanyProfileSearchState, minLength?: number) => {
  const {
    status: getCompanyStatus,
    isFetching: getCompanyIsLoading,
    data: getCompanyData,
    error: getCompanyError,
    refetch: fetchCompanyProfiles,
  } = useQuery<GetCompanyProfileResponse, CustomAxiosError>(['company/get', req], () => getCompanyProfiles(req), {
    keepPreviousData: true,
    enabled: typeof minLength === 'number' ? req.companyName.length >= minLength : true,
  })

  return {
    getCompanyStatus,
    getCompanyIsLoading,
    getCompanyData,
    getCompanyError,
    fetchCompanyProfiles,
  }
}
